import React from "react";

export const useVisibleColumns = (columns) => {
  const visibleColumns = React.useMemo(() => columns.filter((c) => !c.hidden), [
    columns
  ]);

  return visibleColumns;
};
